/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    hreflang?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    deprecation?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    profile?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    templated?: boolean;
}

/**
 * Check if a given object implements the Link interface.
 */
export function instanceOfLink(value: object): boolean {
    return true;
}

export function LinkFromJSON(json: any): Link {
    return LinkFromJSONTyped(json, false);
}

export function LinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Link {
    if (json == null) {
        return json;
    }
    return {
        
        'href': json['href'] == null ? undefined : json['href'],
        'hreflang': json['hreflang'] == null ? undefined : json['hreflang'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'deprecation': json['deprecation'] == null ? undefined : json['deprecation'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'name': json['name'] == null ? undefined : json['name'],
        'templated': json['templated'] == null ? undefined : json['templated'],
    };
}

export function LinkToJSON(value?: Link | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'href': value['href'],
        'hreflang': value['hreflang'],
        'title': value['title'],
        'type': value['type'],
        'deprecation': value['deprecation'],
        'profile': value['profile'],
        'name': value['name'],
        'templated': value['templated'],
    };
}

